import * as SubframeCore from '@subframe/core';
import { TimelineStepAttachment } from 'modules/Recruit/types';
import React from 'react';
import { IconButton } from 'subframe/components/IconButton';

interface AttachmentCardProps {
  attachment: TimelineStepAttachment;
}

export const AttachmentCard: React.FC<AttachmentCardProps> = ({ attachment }) => {
  return (
    <div className="flex h-16 w-72 flex-none items-center justify-between rounded-md bg-neutral-50 px-3 py-2">
      <div className="flex min-w-0 items-center gap-2 flex-1">
        <SubframeCore.Icon name="FeatherFile" className="text-subtext-color flex-shrink-0" />
        <div className="flex flex-col items-start gap-1 min-w-0 flex-1">
          <span className="text-body-bold font-body-bold text-neutral-700 truncate w-full">
            {attachment.file_name}
          </span>
          {attachment.uploaded_at && (
            <span className="text-label font-label text-subtext-color truncate w-full">
              Uploaded {new Date(attachment.uploaded_at).toLocaleDateString()}
            </span>
          )}
        </div>
      </div>
      <div className="flex items-center gap-1 flex-shrink-0 ml-2">
        <IconButton
          variant="neutral-secondary"
          size="small"
          icon="FeatherDownload"
          onClick={() => window.open(attachment.download_url, '_blank')}
        />
      </div>
    </div>
  );
};
